import React from "react";
import { PhotoHero } from "./PhotoHero";
import { COLORS } from "../theme";

// Foto real: operador escaneando el QR en el puerto, con el buque al fondo.
export const SPuerto: React.FC = () => (
  <PhotoHero
    src="footage/escaneo-puerto.png"
    kicker="En el puerto"
    kickerColor={COLORS.blueLight}
    title="Del barco a tierra, bajo control"
    origin="62% 60%"
  />
);
